import { MAX_INQUIRY_NOTIFICATION_EMAILS } from "@kansai-ai-hub/types";
import { z } from "zod";
/**
 * 「お問い合わせが届いたときに通知する宛先」の一括置換。
 *
 * 部分更新（1 件ずつ追加 / 削除）ではなく**一括置換**にしているのは、UI が
 * `NotificationEmailRows`（行を足したり消したりして最後に保存する）だから。
 * 1 件ずつの API にすると、画面の状態と保存済みの状態を突き合わせる処理が
 * フロント側に必要になり、そこがずれると宛先が消えたり二重になったりする。
 *
 * 空欄行を許すのはフォームで行を足した直後を弾かないため。空欄・重複・大小文字差は
 * サーバー側で除去・正規化する（`notificationEmailsSchema` と同じ運用）。
 */
export const inquiryNotificationEmailsSchema = z.object({
    emails: z
        .array(z
        .string()
        .max(320)
        .refine((s) => {
        const t = s.trim();
        return t === "" || z.string().email().safeParse(t).success;
    }, "有効なメールアドレスを入力してください"))
        /*
         * 配列そのものの長さにも上限を置く。実件数の上限（下の refine）は空欄行を
         * 数えないので、これが無いと**空文字だけの巨大な配列が検証を通り抜ける**。
         * 通ったあとサーバーは全要素を trim / 小文字化して Set に入れるので、
         * 画面側のバグ（行の複製ループ等）がそのまま CPU を食う経路になる。
         * 空欄行を許す設計なので、実件数の上限より少し緩く取る。
         */
        .max(MAX_INQUIRY_NOTIFICATION_EMAILS * 2, `入力欄が多すぎます（通知先は最大${MAX_INQUIRY_NOTIFICATION_EMAILS}件までです）`)
        // 上限は「実メール件数」で数える（空欄行は計数しない）。
        .refine((arr) => arr.filter((s) => s.trim() !== "").length <= MAX_INQUIRY_NOTIFICATION_EMAILS, `通知先は最大${MAX_INQUIRY_NOTIFICATION_EMAILS}件までです`),
});
